// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------
import request from '@/api/request';
import {getToken} from "@/utils/auth";



export function getStyleApi() {
  return request({
      url:`change/color`,
});
}

/**
 * @description 身份管理 -- 列表
 */
export function menuRoleApi(data: any) {
  return request({
    url: 'system/role/lst',
    method: 'get',
    params: data,
  });
}

/**
 * @description 身份管理 -- 新增
 */
export function roleCreateApi() {
  return request({
    url: 'system/role/create/form',
    method: 'get',
  });
}

/**
 * @description 身份管理 -- 编辑
 */
export function roleUpdateApi(id: number | string) {
  return request({
    url: `system/role/update/form/${id}`,
    method: 'get',
  });
}

/**
 * @description 身份管理 -- 删除
 */
export function roleDeleteApi(id: number | string) {
  return request({
    url: `system/role/delete/${id}`,
    method: 'delete',
  });
}

/**
 * @description 身份管理 -- 修改状态
 */
export function roleStatusApi(id: number | string, status: number) {
  return request({
    url: `system/role/status/${id}`,
    method: 'post',
    data: { status },
  });
}

/**
 * @description 管理员 -- 列表
 */
export function adminListApi(data: any) {
  return request({
    url: 'system/admin/lst',
    method: 'get',
    params: data,
  });
}

/**
 * @description 管理员 -- 新增
 */
export function adminCreateApi() {
  return request({
    url: '/system/admin/create/form',
    method: 'get',
  });
}

/**
 * @description 管理员 -- 编辑
 */
export function adminUpdateApi(id: number | string) {
  return request({
    url: `system/admin/update/form/${id}`,
    method: 'get',
  });
}

/**
 * @description 管理员 -- 删除
 */
export function adminDeleteApi(id: number | string) {
  return request({
    url: `system/admin/delete/${id}`,
    method: 'delete',
  });
}

/**
 * @description 管理员 -- 修改状态
 */
export function adminStatusApi(id: number | string, status: number) {
  return request({
    url: `system/admin/status/${id}`,
    method: 'post',
    data: { status },
  });
}

/**
 * @description 管理员 -- 修改密码表单
 */
export function adminPasswordApi(id: number | string) {
  return request({
    url: `system/admin/password/form/${id}`,
    method: 'get',
  });
}

/**
 * @description 操作日志 -- 列表
 */
export function adminLogApi(data: any) {
  return request({
    url: 'system/admin/log',
    method: 'get',
    params: data,
  });
}

/**
 * @description 自提 -- 详情
 */
export function storeGetInfoApi() {
  return request({
    url: 'take/info',
    method: 'get',
  });
}

/**
 * @description 自提 -- 提交
 */
export function storeUpdateApi(data: any) {
  return request({
    url: 'take/update',
    method: 'post',
    data,
  });
}

/**
 * @description 上传资质图片
 */
export function uploadCertificate(data: any) {
  return request({
    url: 'upload/certificate',
    method: 'post',
    data,
  });
}

/**
 * @description 保证金支付二维码
 */
export function marginCode() {
  return request({
    url: 'margin/code',
    method: 'get',
  });
}

/**
 * @description 补缴保证金支付二维码
 */
export function marginMakeCode() {
  return request({
    url: 'margin/make_code',
    method: 'get',
  });
}

/**
 * @description 保证金记录
 */
export function marginRecordLst(data: any) {
  return request({
    url: 'margin/lst',
    method: 'get',
    params: data,
  });
}

/**
 * @description 申请退回保证金(只返回信息)
 */
export function marginRefund() {
  return request({
    url: 'financial/refund/margin',
    method: 'post',
  });
}

/**
 * @description 申请退回保证金(申请退)
 */
export function marginRefundApply(data: any) {
  return request({
    url: 'financial/refund/margin_apply',
    method: 'post',
    data,
  });
}

/**
 * @description 一号通 -- 用户信息
 */
export function serveInfoApi() {
  return request({
    url: 'serve/info',
    method: 'get',
  });
}

/**
 * @description 一号通 -- 是否登录
 */
export function smsPriceApi(data: any) {
  return request({
    url: 'serve/meal',
    method: 'get',
    params: data,
  });
}

/**
 * @description 一号通短信账户 -- 支付二维码
 */
export function payCodeApi(data: any) {
  return request({
    url: 'serve/code',
    method: 'get',
    params: data,
  });
}

/**
 * @description 一号通短信账户 -- 列表
 */
export function serveRecordListApi(data: any) {
  return request({
    url: 'serve/record',
    method: 'get',
    params: data,
  });
}

/**
 * @description 短信账户签名修改 -- 获取验证码
 */
export function captchaApi(phone: string) {
  return request({
    url: `serve/captcha/${phone}`,
    method: 'get',
  });
}

/**
 * @description 一号通 -- 购买记录
 */
export function payRecordLst(data: any) {
  return request({
    url: 'serve/paylst',
    method: 'get',
    params: data,
  });
}

/**
 * @description 电子面单配置 -- 快递公司列表
 */
export function getExpressLst() {
  return request({
    url: 'serve/expr/lst',
    method: 'get',
  });
}

/**
 * @description 电子面单配置 -- 电子面单列表
 */
export function getdumpLst(data: any) {
  return request({
    url: 'expr/temps',
    method: 'get',
    params: data,
  });
}

/**
 * @description 电子面单配置 -- 获取数据
 */
export function getdumpDataApi() {
  return request({
    url: 'serve/config',
    method: 'get',
  });
}

/**
 * @description 电子面单配置 -- 提交数据
 */
export function updatedumpDataApi(data: any) {
  return request({
    url: 'serve/config',
    method: 'post',
    data,
  });
}

/**
 * @description 打印机配置 -- 添加
 */
export function printerAddApi() {
  return request({
    url: 'store/printer/create/form',
    method: 'get',
  });
}

/**
 * @description 打印机配置 -- 列表
 */
export function printerLstApi(data: any) {
  return request({
    url: 'store/printer/lst',
    method: 'get',
    params: data,
  });
}

/**
 * @description 打印机 -- 是否开启
 */
export function printerStatusApi(id: number | string, status: number) {
  return request({
    url: `store/printer/status/${id}`,
    method: 'post',
    data: { status },
  });
}

/**
 * @description 打印机配置 -- 编辑
 */
export function printerUpdateApi(id: number | string) {
  return request({
    url: `store/printer/update/${id}/form`,
    method: 'get',
  });
}

/**
 * @description 打印机配置 -- 删除
 */
export function printerDeleteApi(id: number | string) {
  return request({
    url: `store/printer/delete/${id}`,
    method: 'delete',
  });
}

/**
 * @description 扫码上传链接获取
 */
export function scanUploadQrcode(pid: number | string) {
  return request({
    url: `system/attachment/scan_upload/qrcode/${pid}`,
    method: 'get',
  });
}

/**
 * @description 扫码上传获取图片
 */
export function scanUploadGet(scanToken: string) {
  return request({
    url: `system/attachment/scan_upload/image/${scanToken}`,
    method: 'get',
  });
}

/**
 * @description 扫码上传提交
 */
export function scanUploadSave(scanToken: string, data: any) {
  return request({
    url: `system/attachment/scan_upload/image/${scanToken}`,
    method: 'post',
    data,
  });
}

/**
 * @description 扫码上传提交数据
 */
export function fileUpload(id: number | string, field: any) {
  return request({
    url: `upload/image/${id}/file`,
    method: 'post',
    data: field,
    headers: {
      repeatSubmit: false,
      'Authorization': 'Bearer ' + getToken(),
      'content-type': 'multipart/form-data;' + 'Bearer ' + getToken(),
    },
  });
}

/**
 * @description 上传文件提交数据
 */
export function fileUploadApi(field) {
  return request({
    url: `upload/files/file`,
    method: 'post',
    data: field,
    headers: {
      repeatSubmit: false,
      'Authorization': 'Bearer ' + getToken(),
      'content-type': 'multipart/form-data;' + 'Bearer ' + getToken(),
    },
  });
}



/**
 * @description 网络上传提交数据
 */
export function onlineUpload(data: any) {
  return request({
    url: 'system/attachment/online_upload',
    method: 'post',
    data,
  });
}

/**
 * @description 添加账户--表单
 */
export function addOpenAuth() {
  return request({
    url: 'openapi/create/form',
    method: 'get',
  });
}

/**
 * @description 账户列表
 */
export function openAuthList(data: any) {
  return request({
    url: 'openapi/lst',
    method: 'get',
    params: data,
  });
}

/**
 * @description 账户列表
 */
export function updateOpenAuth(id: number | string) {
  return request({
    url: `openapi/update/${id}/form`,
    method: 'get',
  });
}

/**
 * @description 账户列表 -- 是否开启
 */
export function openAuthStatus(id: number | string, status: number) {
  return request({
    url: `openapi/status/${id}`,
    method: 'post',
    data: { status },
  });
}

/**
 * @description 账户列表 -- 是否开启
 */
export function openAuthDelete(id: number | string) {
  return request({
    url: `openapi/delete/${id}`,
    method: 'delete',
  });
}

/**
 * @description 账户列表 -- 查看secret_key
 */
export function getSecretKey(id: number | string) {
  return request({
    url: `openapi/get_secret_key/${id}`,
    method: 'get',
  });
}

/**
 * @description 账户列表 -- 重置secret_key
 */
export function resetSccretKey(id: number | string) {
  return request({
    url: `openapi/set_secret_key/${id}`,
    method: 'post',
  });
}

/**
 * @description 系统表单--添加
 */
export function systemForm(data: any) {
  return request({
    url: 'store/form/create',
    method: 'post',
    data,
  });
}

/**
 * @description 系统表单--详情
 */
export function systemFormInfo(id: number | string) {
  return request({
    url: `store/form/detail/${id}`,
    method: 'get',
  });
}

/**
 * @description 系统表单--编辑
 */
export function systemFormUpdate(id: number | string, data: any) {
  return request({
    url: `store/form/update/${id}`,
    method: 'post',
    data,
  });
}

/**
 * @description 系统表单--列表
 */
export function systemFormList(data: any) {
  return request({
    url: 'store/form/lst',
    method: 'get',
    params: data,
  });
}

/**
 * @description 系统表单--删除
 */
export function formDeleteApi(id: number | string) {
  return request({
    url: `store/form/delete/${id}`,
    method: 'delete',
  });
}

/**
 * @description 系统表单--详情
 */
export function formDetailList(id: number | string, data: any) {
  return request({
    url: `store/form/user_lst/${id}`,
    method: 'get',
    params: data,
  });
}

/**
 * @description 小票打印--获取小票内容
 */
export function printContent(id: number | string) {
  return request({
    url: `store/printer/get_content/${id}`,
    method: 'get',
  });
}

/**
 * @description 小票打印--保存小票内容
 */
export function printSaveContent(id: number | string, data: any) {
  return request({
    url: `store/printer/set_content/${id}`,
    method: 'post',
    data,
  });
}


/**
 * @description 配送设置--配送设置信息
 */
export function deliverySetApi() {
  return request({url:`/delivery/config/settings`
});
}
/**
 * @description 配送设置--更新配送设置信息
 */
export function deliveryUpdateApi(id:number, data:any) {
  return request({
    url:`/delivery/config/update/${id}`,
    method: 'post',
    data
});
}
